// extracted by mini-css-extract-plugin
export default {"taglineContainer":"Tagline_taglineContainer__F5LuY"};